import request from '../httpClient';

export const getExternalAirbnbListings = (otaAccountId: string | number) =>
  request.post(`/integration/airbnb/${otaAccountId}/listings`, {});

export const chooseAirbnbListings = (otaAccountId: string | number, otaListingIds: (number | string)[]) =>
  request.post(`/integration/airbnb/${otaAccountId}/resources`, {otaListingIds});



// WEBPACK FOOTER //
// ./src/services/api/importListingsApi.ts